import React, { FC, useEffect } from 'react';

import * as Sentry from '@sentry/react';

import * as O from 'fp-ts/Option';
import { pipe } from 'fp-ts/function';
import { HttpError } from '@core/http';
import { Profile } from '@modules/auth/model';
import ErrorPage from '@shared/components/error-page/ErrorPage';

function getSentryUser(profile: O.Option<Profile>): Sentry.User {
  return pipe(
    profile,
    O.fold<Profile, Sentry.User>(
      () => ({ username: 'Not authenticated' }),
      p => ({
        company_user_id: p.id,
        role: p.role,
        company_kind: p.company_kind,
        company_user_role: p.company_user_role,
      }),
    ),
  );
}

interface SentryProviderProps {
  profile: O.Option<Profile>;
}

const SentryProvider: FC<SentryProviderProps> = ({ profile, children }) => {
  useEffect(() => {
    Sentry.configureScope(scope => {
      scope.setUser(getSentryUser(profile));
    });
  }, [profile]);

  return <Sentry.ErrorBoundary fallback={<ErrorPage error={HttpError.default} />}>{children}</Sentry.ErrorBoundary>;
};

export default SentryProvider;
